<template>
  <div class="vuetable-filterbar col-md-12 step-filtrar">
    <div class="form-group">
      <b-container fluid>
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="num_fiscal"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >Nº Fiscal NFe</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="num_carga"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >Nº Carga</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
                locale="pt-br"
                placeholder="Data Expedição Inicial"
                reset-button
                v-model="dt_inicio_expedicao"
                class="form-control"
                :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
                locale="pt-br"
                placeholder="Data Expedição Fim"
                reset-button
                v-model="dt_fim_expedicao"
                class="form-control"
                :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="2" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="num_fiscal_doc_ini"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >Nº do Doc inicial</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="num_fiscal_doc_fim"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >Nº do Doc final</label
              >
            </div>
          </b-col>

          <b-col sm="2" md="1" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="num_fiscal_mdfe"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >Nº MDFe</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="razao_social_red"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >Razão social Redespacho</label
              >
            </div>
          </b-col>
          <b-col sm="4" md="1" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="cnpj_red"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >CNPJ Redespacho</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
                locale="pt-br"
                placeholder="Data Emissão Doc Inicial"
                reset-button
                v-model="dt_emi_doc_ini"
                class="form-control"
                :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
                locale="pt-br"
                placeholder="Data Emissão Doc Fim"
                reset-button
                v-model="dt_emi_doc_fim"
                class="form-control"
                :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="razao_social_rem"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >Razão social Remetente</label
              >
            </div>
          </b-col>
          <b-col sm="1" md="2" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="cnpj_rem"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >CNPJ Remetente</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
                locale="pt-br"
                placeholder="Data Emissão NF Inicial"
                reset-button
                v-model="dt_emissao_nf_ini"
                class="form-control"
                :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
                locale="pt-br"
                placeholder="Data Emissão NF Fim"
                reset-button
                v-model="dt_emissao_nf_fim"
                class="form-control"
                :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
                locale="pt-br"
                placeholder="Data Previsão Ini."
                reset-button
                v-model="dt_previsao_ini"
                class="form-control"
                :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
                locale="pt-br"
                placeholder="Data Previsão Fim"
                reset-button
                v-model="dt_previsao_fim"
                class="form-control"
                :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <multiselect
                v-model="unidade"
                :options="this.$parent.optionsUnidade"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Unidade"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <multiselect
                v-model="veiculo"
                :options="this.$parent.optionsVeiculo"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Veículo"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="4" class="p-a-0 m-t-5px">
            <multiselect
                v-model="fornecedor"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="optionsFornecedor"
                track-by="value"
                label="label"
                id="fornecedor"
                :hide-selected="true"
                placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingFornecedor"
                @search-change="listaFornecedor"
            ></multiselect>
          </b-col>
          <b-col class="p-0 pt-1">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                    type="button"
                    class="btn btn-secondary btn-outline"
                    @click="doFilter"
                    :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                    type="button"
                    class="btn btn-secondary btn-outline"
                    @click="resetFilter"
                    :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      isLoadingFornecedor: false,
      num_fiscal: "",
      num_carga: "",
      dt_inicio_expedicao: "",
      dt_fim_expedicao: "",
      num_fiscal_doc_ini: "",
      num_fiscal_doc_fim: "",
      num_fiscal_mdfe: "",
      razao_social_red: "",
      dt_emissao_nf_ini: "",
      dt_emissao_nf_fim: "",
      cnpj_red: "",
      dt_emi_doc_ini: "",
      dt_emi_doc_fim: "",
      razao_social_rem: "",
      dt_previsao_ini: "",
      dt_previsao_fim: "",
      cnpj_rem: "",
      veiculo: [],
      unidade: [],
      fornecedor: [],
      optionsFornecedor: [],
      data_filter: [],
      helpForm: new Form({ statusRecord: [], params: [], search:"" }),
    };
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        num_fiscal: this.num_fiscal,
        num_carga: this.num_carga,
        dt_inicio_expedicao: this.formatDateSubmit(this.dt_inicio_expedicao),
        dt_fim_expedicao: this.formatDateSubmit(this.dt_fim_expedicao),
        dt_emissao_nf_ini: this.formatDateSubmit(this.dt_emissao_nf_ini),
        dt_emissao_nf_fim: this.formatDateSubmit(this.dt_emissao_nf_fim),
        num_fiscal_doc_ini: this.num_fiscal_doc_ini,
        num_fiscal_doc_fim: this.num_fiscal_doc_fim,
        num_fiscal_mdfe: this.num_fiscal_mdfe,
        razao_social_red: this.razao_social_red,
        cnpj_red: this.cnpj_red,
        dt_emi_doc_ini: this.formatDateSubmit(this.dt_emi_doc_ini),
        dt_emi_doc_fim: this.formatDateSubmit(this.dt_emi_doc_fim),
        dt_previsao_ini: this.formatDateSubmit(this.dt_previsao_ini),
        dt_previsao_fim: this.formatDateSubmit(this.dt_previsao_fim),
        razao_social_rem: this.razao_social_rem,
        cnpj_rem: this.cnpj_rem,
        veiculo: this.veiculo,
        unidade: this.unidade,
        fornecedor: this.fornecedor,
      };
      this.$events.fire("filter-set-posicaonf", this.data_filter);
    },
    resetFilter() {
      this.num_fiscal = "";
      this.num_carga = "";
      this.dt_inicio_expedicao = "";
      this.dt_fim_expedicao = "";
      this.dt_emissao_nf_ini = "";
      this.dt_emissao_nf_fim = "";
      this.num_fiscal_doc_ini = "";
      this.num_fiscal_doc_fim = "";
      this.num_fiscal_mdfe = "";
      this.razao_social_red = "";
      this.cnpj_red = "";
      this.dt_emi_doc_ini = "";
      this.dt_emi_doc_fim = "";
      this.dt_previsao_ini = "";
      this.dt_previsao_fim = "";
      this.razao_social_rem = "";
      this.cnpj_rem = "";
      this.veiculo = "";
      this.unidade = "";
      this.fornecedor = "";
      this.$events.fire("filter-reset-posicaonf");
    },
    listaFornecedor(search) {
      if (search.length >= 3) {
        this.isLoadingFornecedor = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
            .post("/api/pessoa/jsonlist/fornecedor")
            .then((response) => {
              this.optionsFornecedor = [];
              new ReturnApi(response, this, true, false, false);
              if (response.items.length > 0) {
                response.items.forEach((obj) => {
                  this.optionsFornecedor.push({
                    label:
                        "PJ -" +
                        obj.pessoa.cd +
                        " - " +
                        obj.razao_social +
                        " - " +
                        this.onFormataCnpj(
                            obj.cnpj_base,
                            obj.cnpj_filial,
                            obj.cnpj_digito
                        ) +
                        " - " +
                        obj.inscricao_estadual,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                  });
                });
              }
              if (response.itemsF.length > 0) {
                response.itemsF.forEach((obj) => {
                  this.optionsFornecedor.push({
                    label: "PF -" + obj.nome + " - " + obj.cpf,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                  });
                });
              }
              if (response.itemsE.length > 0) {
                response.itemsE.forEach((obj) => {
                  this.optionsFornecedor.push({
                    label: "PE -" + obj.nome + " - " + obj.cd,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                  });
                });
              }
              this.isLoadingFornecedor = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
            });
      }
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
          ? ""
          : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>